import { Advisors } from '../../../interfaces/Advisors';
import { AdvisorsDto } from '../../../interfaces/dtos/AdvisorsDto';
import transformAdvisor from './transformAdvisor';

export default function transformAdvisors(dto: AdvisorsDto): Advisors {
  return {
    advisors: dto?.data?.map((a) => transformAdvisor(a)) ?? [],
  };
}
